<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>DATA EXPORT REQUESTED SUCESSFULLY</title>
  </head>
  <body class="main-bg">
    <div>
      <div class="error-container">
        <h1 class="text-white">Details will be mailed</h1>
        <h2 class="text-white">May take sometime</h2>
        <div class="error-message text-white">
          Thanks for being a valuable user!
        </div>
        <div>
          <a
            href="login"
            class="btn btn btn-lg text-black"
            style="background-color: #FFD958;"
            >Take Me Home</a
          >
          <a href="login" class="btn btn btn-lg text-white">Contact Support</a>
        </div>
      </div>
    </div>
  </body>
</html>


